import produce from "immer";

import {
  FINAL_VOTING_WATCH_ON,
  FINAL_VOTING_WATCH_OFF
} from "../actions/types";

const initialState = {
  dbSync: false
};

export default (state = initialState, action) => {
  return produce(state, draft => {
    // eslint-disable-next-line
    switch (action.type) {
      case FINAL_VOTING_WATCH_ON:
        draft = { dbSync: true, ...action.payload };
        return draft;
      case FINAL_VOTING_WATCH_OFF:
        draft = initialState;
        return draft;
    }
  });
};
